/**
 * SiteHeaderAccountLink — Iter 191u
 *
 * Small "Sign in" / "Account" chip rendered inside the public storefront
 * header, right next to the CartDrawerTrigger. Reads the per-subdomain
 * buyer session token from localStorage to decide the label, and fetches
 * the vendor's customer-account config to know whether accounts are
 * enabled — if the vendor turned accounts off, the link hides entirely.
 */
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { User } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

function inferSubdomain(pathname) {
  const m = pathname.match(/^\/site\/([^/]+)/);
  return m ? m[1] : null;
}

export default function SiteHeaderAccountLink({ color = '#0f172a', subdomainOverride }) {
  const { pathname } = useLocation();
  const subdomain = subdomainOverride || inferSubdomain(pathname);
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    if (!subdomain) return;
    let cancelled = false;
    axios.get(`${API}/public/buyers/${subdomain}/config`)
      .then(({ data }) => { if (!cancelled) setEnabled(!!data?.enabled); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [subdomain]);

  if (!enabled || !subdomain) return null;

  const signedIn = !!localStorage.getItem(`entrepren_buyer_session:${subdomain}`);
  const to       = `/site/${subdomain}/account`;
  const label    = signedIn ? 'Account' : 'Sign in';

  return (
    <Link
      to={to}
      className="inline-flex items-center gap-1.5 text-sm font-medium hover:opacity-75 transition-opacity"
      style={{ color }}
      data-testid="site-header-account-link"
      aria-label={label}
    >
      <User size={15} />
      <span className="hidden sm:inline">{label}</span>
    </Link>
  );
}
